export class RetrieveGiftCardBalance {
    balance: number;
    success: boolean;
    message: string;
    supportstip: boolean;

    public static Make(obj: any): RetrieveGiftCardBalance {
        const retrieveGiftCardBalance = new RetrieveGiftCardBalance();
        Object.assign(retrieveGiftCardBalance, obj);
        return retrieveGiftCardBalance;
    }
}
